import { Dialog } from "@mui/material";
import { styled } from "@mui/material";
export default styled(Dialog)(({ theme, ownerState }) => {
  const { width } = ownerState;
  return {
    "& .MuiDialog-paper": {
      width,
    },
    "& .MuiDialogTitle-root": {
      padding: "15px",
    },
    "& .css-1peo4km-MuiPaper-root-MuiDialog-paper": {
      borderRadius: "0.5rem",
    },
    "& .MuiDialogContent-root": {
      padding: "15px",
    },
  };
});
